export default {
    share: {
        copySuccess: '複製成功'
    }
};


